<div class="modal-header">
  <h5 class="modal-title">Incomming Parking Lot Message Information</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  @if (loading) {
    <div>Loading...</div>
  }
  @if (error) {
    <div class="text-danger">{{ error }}</div>
  }
  @if (!loading && !error) {
    <ul ngbNav #nav="ngbNav" class="nav-tabs mb-3">     
      <li [ngbNavItem]="2">
        <button ngbNavLink>Details</button>        
        <ng-template ngbNavContent>
          @if (itemDetailLoading) {
            <div class="d-flex align-items-center gap-2 py-2 ps-2">
              <div class="spinner-border spinner-border-sm" role="status"></div>
              <span>Loading...</span>
            </div>
          }
          @if (itemDetailError) {
            <div class="alert alert-danger py-1 px-2 my-1">{{ itemDetailError }}</div>
          }
          @if (!itemDetailLoading && !itemDetailError && itemDetail) {
            <b>Note:</b> The details view is based on the incoming message payload, which may not contain all the details shown in the grid, as some of them are calculate based on rules (for exemple Lifecycle management status). Therefore, some fields may be empty in the details view if they are not present in the incoming message.
            <fieldset class="border p-2" style="margin-top: 10px;">
              <legend class="float-none w-auto legend-style"><span style="margin-left: 5px; margin-right: 5px;">Item details</span></legend>
              <div class="row mb5">
                <div class="col-sm-3"><label><b>Item ID:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.itemDetails?.itemId }}</label></div>
                <div class="col-sm-3"><label><b>Description:</b></label></div>
                <div class="col-sm-3"><label>{{itemDetail.itemDetails?.description }}</label></div>
              </div>
              <div class="row mb5">
                <div class="col-sm-3"><label><b>Detailed description:</b></label></div>
                <div class="col-sm-3"><label>{{itemDetail.itemDetails?.detailedDescription }}</label></div>
                <div class="col-sm-3"><label><b>Base UOM code:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.itemDetails?.baseUOMCode }}</label></div>
              </div>
              <div class="row mb5">
                <div class="col-sm-3"><label><b>Origin source:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.origin?.originSource }}</label></div>
                <div class="col-sm-3"><label><b>Publishing source:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.origin?.publishingSource }}</label></div>
              </div>
              <div class="row mb5">
                <div class="col-sm-3"><label><b>ALSIS product code:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.itemDetails?.alsisProductCode }}</label></div>
                <div class="col-sm-3"><label><b>ALSIS scope:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.itemDetails?.alsisScope }}</label></div>
              </div>
              <div class="row mb5">
                <div class="col-sm-3"><label><b>Item classification:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.classification?.itemClassification }}</label></div>
                <div class="col-sm-3"><label><b>Item classification description:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.classification?.itemClassificationDescription }}</label></div>
              </div>
              <div class="row mb5">
                <div class="col-sm-3"><label><b>Item state:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.status?.itemState }} ({{ utilService.getItemStateDescription(itemDetail.status?.itemState, itemDetail.status?.itemStateDescription) }})</label></div>
                <div class="col-sm-3"><label><b>Lifecycle management status:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.status?.lifecycleManagementStatus }}</label></div>
              </div>
              <div class="row mb5">
                <div class="col-sm-3"><label><b>Taxonomy node ID:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.classification?.taxonomyNodeId }}</label></div>
                <div class="col-sm-3"><label><b>Taxonomy node name:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.classification?.taxonomyNodeName }}</label></div>
              </div>
              <div class="row mb5">
                <div class="col-sm-3"><label><b>Alternate item ID:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.itemDetails?.alternateItemId }}</label></div>
                <div class="col-sm-3"><label><b>Original source publish time:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.origin?.originalSourcePublishTime }}</label></div>
              </div>
              <div class="row mb5">
                <div class="col-sm-3"><label><b>Is spare part:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.itemDetails?.isSparePart ? 'Yes' : 'No' }}</label></div>
                <div class="col-sm-3"><label><b>Current item ID:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.itemDetails?.currentItemId }}</label></div>
              </div>
              <div class="row mb5">
                <div class="col-sm-3"><label><b>Is AlfaLaval item:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.itemDetails?.isAlfaLavalItem ? 'Yes' : 'No' }}</label></div>
                <div class="col-sm-3"><label><b>Is sales item:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.itemDetails?.isSalesItem ? 'Yes' : 'No' }}</label></div>
              </div>
              <div class="row mb5">
                <div class="col-sm-3"><label><b>Is configured:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.itemDetails?.isConfigured ? 'Yes' : 'No' }}</label></div>
                <div class="col-sm-3"><label><b>Alternate items:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.itemDetails?.alternateItems?.join(', ') || 'None' }}</label></div>
              </div>
              <div class="row mb5">
                <div class="col-sm-3"><label><b>Supersedes:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.itemDetails?.supersedes?.join(', ') || 'None' }}</label></div>
                <div class="col-sm-3"><label><b>Revision ID:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.itemDetails?.revisionId }}</label></div>
              </div>
              <div class="row mb5">
                <div class="col-sm-3"><label><b>Configuration ID:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.itemDetails?.configurationId }}</label></div>
                @if (itemDetail.status?.isMarkedForDeletion) {
                  <div class="col-sm-3"><label><b>Marked for deletion date:</b></label></div>
                  <div class="col-sm-3"><label>{{ itemDetail.status?.markedForDeletionDateTime }}</label></div>
                }
              </div>
              <div class="row mb5">
                <div class="col-sm-3"><label><b>Item created date:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.timestamps?.itemCreatedDateTime | date: 'yyyy-MM-dd HH:mm:ss' }}</label></div>
                <div class="col-sm-3"><label><b>Last modification date:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.timestamps?.lastModificationDateTime | date: 'yyyy-MM-dd HH:mm:ss' }}</label></div>
              </div>
              <div class="row mb5">
                <div class="col-sm-3"><label><b>Created date:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.timestamps?.createdDateTime | date: 'yyyy-MM-dd HH:mm:ss' }}</label></div>
                <div class="col-sm-3"><label><b>Update date:</b></label></div>
                <div class="col-sm-3"><label>{{ itemDetail.timestamps?.updateDateTime | date: 'yyyy-MM-dd HH:mm:ss' }}</label></div>
              </div>
            </fieldset>

            @if (itemDetail.suppliers?.length) {
              <fieldset class="border p-2" style="margin-top: 10px;">
                <legend class="float-none w-auto legend-style"><span style="margin-left: 5px; margin-right: 5px;">Suppliers</span></legend>
                <kendo-grid [data]="itemDetail.suppliers" [scrollable]="'none'">
                  <kendo-grid-column field="supplierDetails.supplierId" title="Supplier ID" [width]="120"></kendo-grid-column>
                  <kendo-grid-column field="supplierDetails.isMainSupplier" title="Main Supplier" [width]="100">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{ dataItem.supplierDetails?.isMainSupplier ? 'YES' : 'NO' }}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="supplierDetails.stockCode" title="Stock Code" [width]="100"></kendo-grid-column>
                  <kendo-grid-column field="supplierDetails.legalEntity" title="Legal Entity" [width]="110"></kendo-grid-column>
                  <kendo-grid-column field="supplierDetails.legalEntityName" title="Legal Entity Name"></kendo-grid-column>
                  <kendo-grid-column field="supplierDetails.siteId" title="Site ID" [width]="80"></kendo-grid-column>
                  <kendo-grid-column field="supplierDetails.baseUOMCode" title="Base UOM" [width]="90"></kendo-grid-column>
                  <kendo-grid-column field="supplierDetails.supplierItemIdentification" title="Supplier Item ID" [width]="130"></kendo-grid-column>
                  <kendo-grid-column field="timestamps.updateDateTime" title="Last Modified" [width]="160">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{ dataItem.timestamps?.updateDateTime | date: 'yyyy-MM-dd HH:mm:ss' }}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column title="" [width]="55">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <button class="btn btn-outline-secondary btn-sm" (click)="viewSupplier(dataItem)" title="View supplier">
                        <i class="fa fa-magnifying-glass" aria-hidden="true"></i>
                      </button>
                    </ng-template>
                  </kendo-grid-column>
                </kendo-grid>
              </fieldset>
            }
          }
        </ng-template>
      </li>
       <li [ngbNavItem]="1">
        <button ngbNavLink>Internal Message Payload</button>
        <ng-template ngbNavContent>
          <div class="d-flex justify-content-end mb-1">
            <button class="btn btn-outline-secondary btn-sm" (click)="copyToClipboard()" title="Copy to clipboard">
              <i class="fa fa-copy me-1" aria-hidden="true"></i>Copy to clipboard
            </button>
          </div>
          <pre class="json-display" [innerHTML]="syntaxHighlightedJson"></pre>
        </ng-template>
      </li>
      @if (parkingLotModel.referenceId) {
        <li [ngbNavItem]="3">
          <button ngbNavLink>Original Message</button>
          <ng-template ngbNavContent>
            @if (originalMessageLoading) {
              <div class="d-flex align-items-center gap-2 py-2 ps-2">
                <div class="spinner-border spinner-border-sm" role="status"></div>
                <span>Loading...</span>
              </div>
            }
            @if (originalMessageError) {
              <div class="alert alert-danger py-1 px-2 my-1">{{ originalMessageError }}</div>
            }
            @if (!originalMessageLoading && !originalMessageError && originalMessageData !== null) {
              <div class="d-flex justify-content-end mb-1">
                <button class="btn btn-outline-secondary btn-sm" (click)="copyOriginalMessageToClipboard()" title="Copy to clipboard">
                  <i class="fa fa-copy me-1" aria-hidden="true"></i>Copy to clipboard
                </button>
              </div>
              <pre class="json-display" [innerHTML]="syntaxHighlightedOriginalMessage"></pre>
            }
          </ng-template>
        </li>
      }
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Close</button>
</div>

<style>
  .json-display {
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 15px;
    max-height: 500px;
    overflow: auto;
    font-family: 'Courier New', Courier, monospace;
    font-size: 12px;
    white-space: pre-wrap;
    word-wrap: break-word;
  }

  ::ng-deep .json-display .json-key {
    color: #881391;
    font-weight: bold;
  }

  ::ng-deep .json-display .json-string {
    color: #0b7500;
  }

  ::ng-deep .json-display .json-number {
    color: #1750eb;
  }

  ::ng-deep .json-display .json-boolean {
    color: #0000ff;
  }

  ::ng-deep .json-display .json-null {
    color: #808080;
  }

  /* XML highlighting */
  ::ng-deep .json-display .xml-bracket {
    color: #0000cc;
    font-weight: bold;
  }

  ::ng-deep .json-display .xml-element {
    color: #000080;
    font-weight: bold;
  }

  ::ng-deep .json-display .xml-attr-name {
    color: #994500;
  }

  ::ng-deep .json-display .xml-attr-value {
    color: #1a1aa6;
    font-weight: bold;
  }

  ::ng-deep .json-display .xml-comment {
    color: #808080;
    font-style: italic;
  }

  ::ng-deep .json-display .xml-decl {
    color: #606060;
  }

  ::ng-deep .json-display .xml-pi-delim {
    color: #ff0000;
    background-color: #ffff00;
    font-weight: bold;
  }

  ::ng-deep .json-display .xml-pi-attr-name {
    color: #ff0000;
  }

  ::ng-deep .json-display .plain-text {
    color: #000000;
  }
</style>
